<template>
  <p-create v-if="$hasPermission('messages')" />
  <p-not-found v-else />
</template>

<script>
import Create from './../components/messages/CreateMessage.vue';
import NotFound from './../components/NotFound.vue';
export default {
  components: {
    'p-not-found': NotFound,
    'p-create': Create
  }
};
</script>
